module.exports = __webpack_public_path__ + "side_cod.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/side_cod.svg
// module id = 1341
// module chunks = 0